import { createAction, props } from '@ngrx/store';

export enum ProposalShellActionTypes {
  Init = '[Proposals Shell] Init',
  GetConfig = '[Proposals Shell] Get Config',
}

// TODO: (JC) Actions should not be "verb" like
export const ProposalShellActions = {
  init: createAction(ProposalShellActionTypes.Init),
  getConfig: createAction(
    ProposalShellActionTypes.GetConfig,
    props<{ portalId: number; configId: number }>()
  ),
};
